// ova ima svoju kompiju u weightsUtilsCommonJS - jedini razlog je import/export razlika ES6 i CommonJS, ostalo je sve copy paste

import moment from "moment";

export default {
  getTodayWeight(weightHistory) {
    let text = "";
    let todayWeight = weightHistory.find((w) =>
      moment()
        .startOf("day")
        .isSame(w.date)
    );
    todayWeight = todayWeight ? todayWeight.value : todayWeight;
    if (todayWeight) {
      text += todayWeight.toFixed(1);
    } else {
      text = "-";
    }
    return text;
  },
  getWeekWeight(weightHistory) {
    return this.getWeight(weightHistory, "week");
  },
  getMonthWeight(weightHistory) {
    return this.getWeight(weightHistory, "month");
  },
  getWeight(weightHistory, period) {
    let text = "";
    let weights = weightHistory
      .filter((w) =>
        moment()
          .locale("hr")
          .startOf(period)
          .isSameOrBefore(w.date)
      )
      .map((w) => w.value);
    if (weights.length === 0) return "-";
    const sum = weights.reduce((a, b) => a + b, 0);
    let thisWeekAverage = sum / weights.length;
    if (thisWeekAverage) {
      text += thisWeekAverage.toFixed(1);
      let lastPeriodWeights = weightHistory
        .filter(
          (w) =>
            moment()
              .locale("hr")
              .startOf(period)
              .isAfter(w.date) &&
            moment()
              .locale("hr")
              .startOf(period)
              .add(-1, period + "s")
              .isSameOrBefore(w.date)
        )
        .map((w) => w.value);
      if (lastPeriodWeights.length > 0) {
        const sum = lastPeriodWeights.reduce((a, b) => a + b, 0);
        let lastWeekAverage = sum / lastPeriodWeights.length;
        let diff = thisWeekAverage - lastWeekAverage;
        text += " (" + (diff > 0 ? "+" : "") + diff.toFixed(1) + ")";
      }
    } else {
      text = "-";
    }
    return text;
  },
};
